<template>
  <div>
    <yxtf-dialog
      :title="$t('pc_biz_lbl_joinlib'/** 加入知识库 */)"
      :visible.sync="visible"
      append-to-body
      :close-on-click-modal="false"
      width="520px"
      @closed="closed"
    >
      <!-- loading 遮罩 -->
      <i v-if="loading" class="yxtbiz-joinlib_loading pa right-top text-center">
        <yxtf-svg
          width="20px"
          height="20px"
          icon-class="loading"
          class="pa"
        />
      </i>
      <yxtf-form
        ref="form"
        :model="ruleForm"
        :rules="rules"
        label-width="80px"
        :label-position="labelPosition"
      >
        <yxtf-form-item prop="title" :label="$t('pc_biz_lbl_kngname'/** 知识名称 */)">
          <yxtf-input
            v-model.trim="ruleForm.title"
            :maxlength="maxLen"
            show-word-limit
            :placeholder="$t('pc_biz_lbl_kngnameplaceholder'/** 请输入知识名称 */)"
            @keyup.enter.prevent
          />
        </yxtf-form-item>
        <yxtf-form-item prop="libId" :label="$t('pc_biz_lbl_lib'/** 知识库 */)">
          <LibSelect
            ref="libSelect"
            :file-id="fileId"
            :storage-type="storageType"
            @change="libChange"
          />
        </yxtf-form-item>
        <yxtf-form-item prop="catalogId" :label="$t('pc_biz_lbl_folder'/** 文件夹 */)">
          <FolderSelect
            ref="folderSelect"
            v-model="ruleForm.catalogId"
            :lib-id="ruleForm.libId"
            :has-create-permission="hasCreatePermission"
            @add="addFolder"
          />
        </yxtf-form-item>
      </yxtf-form>
      <template slot="footer">
        <!-- <yxtf-button plain @click="visible = false">{{ $t('pc_biz_core_btn_cancel') }}</yxtf-button> -->
        <CancelButton @click="visible = false" />
        <yxtf-button type="primary" :loading="submiting" @click="save">{{ $t('pc_biz_core_btn_confirm') }}</yxtf-button>
      </template>
    </yxtf-dialog>
    <!-- 新建目录 -->
    <AddFolder ref="add" :label-position="labelPosition" />
    <!-- 错误提示框 -->
    <yxtf-dialog
      padding-size='small'
      :visible.sync="errorVisible"
      append-to-body
      :show-close="false"
      width="400px"
      :close-on-click-modal="false"
      :model="false"
      @closed="closed"
    >
      <div class="yxtbiz-joinlib_flex yxtbiz-joinlib_errordialog">
        <i class="yxt-icon-warning yxtf-color-warning font-size-20"></i>
        <p class="yxtbiz-joinlib_flex1 text-26 lh22 break">{{ $t('pc_biz_msg_nolib'/** 无法找到可加入的知识库，可联系管理员新建知识库或修改知识库存储方式。 */) }}</p>
      </div>
      <div class="mt20 clearfix">
        <yxtf-button type="primary" class="pull-right" @click="errorVisible = false">{{ $t('pc_biz_core_btn_determine') }}</yxtf-button>
      </div>
    </yxtf-dialog>
  </div>
</template>

<script>
import { FrontMessage } from 'yxt-pc';
import LibSelect from './libSelect';
import FolderSelect from './folderSelect';
import AddFolder from './addFolder';
import CancelButton from './cancelButton';
import commonUtil from '../../../common-util';
import { getLibs, addKng, getOrgUrl } from '../service.js';

export default {
  name: '',
  inject: ['svgUrl', 'submitSensors'],
  provide() {
    return {
      toast: this.toast
    };
  },
  components: { LibSelect, FolderSelect, AddFolder, CancelButton },
  props: {
    fileId: String, // 文件id
    fileName: String, // 文件名称
    fileSize: Number, // 文件大小
    fileSizeType: String, // 文件大小单位
    fileExt: String, // 文件扩展名
    storageType: [String, Number], // 文件的存储方式：1-公有云存储，2-私有云存储
    scene: [String, Number], // 1.培训作业-学员端 2.培训作业-管理端 3.面授 4.下载中心 5.会议
    link: String, // 外链地址
    linkName: String, // 外链的标题
    intraLink: Boolean // 是否是内部链接
  },
  data() {
    const checkFileName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('pc_biz_lbl_kngnameplaceholder')));
      }
      if (value.length > this.maxLen) {
        return callback(new Error(this.$t('pc_biz_lbl_kngnamemax', [this.maxLen])));
      }
      callback();
    };
    return {
      visible: false,
      errorVisible: false,
      addFolderVisible: false,
      loading: false,
      submiting: false,
      hasCreatePermission: false, // 新建目录权限
      labelPosition: commonUtil.getLanguage() === 'en' ? 'top' : '',
      maxLen: 50,
      ruleForm: {
        title: '',
        libId: '',
        catalogId: ''
      },
      rules: {
        title: [
          { required: true, validator: checkFileName, trigger: 'blur' }
        ]
      },
      baseUrl: ''
    };
  },
  mounted() {
    this.getUrl();
  },
  methods: {
    async getUrl() {
      try {
        const cacheOrgid = window.localStorage.orgId;
        if (!cacheOrgid) {
          return;
        }
        const res = await getOrgUrl(cacheOrgid);
        this.baseUrl = res.pcUrl || '';
      } catch (error) {
        this.toast(error, 'error');
      }
    },
    init(inInit) {
      this.loading = true;
      let libId = window.localStorage.biz_libId;
      let catalogId = window.localStorage.biz_catalogId;

      // 兼容外链
      this.ruleForm.title = this.linkName || this.fileName;

      let param = {
        libId,
        catalogId,
        storageType: this.storageType
      };

      if (!this.link) {
        param.fileId = this.fileId;
      }
      getLibs(param).then(res => {
        let kngLibList = res.kngLibList || [];
        // 没有可用的知识库
        if (kngLibList.length === 0) {
          this.errorVisible = true;
          return;
        }
        // 没有缓存知识库 id，或者缓存的知识库 id 不可用
        if (!libId || !kngLibList.some(item => item.id === libId)) {
          libId = kngLibList[0].id;
        }
        this.ruleForm.libId = libId;
        this.$nextTick(() => {
          this.$refs.libSelect.initData(libId, kngLibList);
          let { cataLogId: id = libId, cataLogName: label = this.$t('pc_biz_lbl_rootfolder'/** 根目录 */) } = res.catalog || {};
          this.$refs.folderSelect.initData({ id, label });
          this.ruleForm.catalogId = id;
        });
        this.visible = true;
      }).catch(e => {
        this.toast(e, 'error');
        this.closed();
      }).then(() => {
        this.loading = false;
      });
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    save() {
      this.$refs.form.validate().then(() => {
        this.submiting = true;
        let { libId, catalogId } = this.ruleForm;

        let param;
        if (this.link) {
          param = {
            title: this.ruleForm.title,
            fileExt: '.link',
            authType: this.intraLink ? 1 : 0, // 链接知识登录类型，0不限制，1：token登录
            indexPath: this.link,
            libId: catalogId, // 目录 id
            storageType: this.storageType
          };
        } else {
          param = {
            title: this.ruleForm.title,
            fileExt: this.fileExt.startsWith('.') ? this.fileExt : `.${this.fileExt}`,
            fileId: this.fileId,
            fileSize: this.fileSizeType.toUpperCase() === 'BYTE' ? window.parseInt(this.fileSize / 1024) : this.fileSize, // 换算成KB
            libId: catalogId, // 目录 id
            storageType: this.storageType
            // storageLocationId: 0, // 私有云服务器组 id
            // storageLocationName: '',
            // description: '',
            // externalFlag: 0 // 允许外部使用（0-不允许，1-允许）
          };
        }

        addKng([param]).then(res => {
          // 上报神策日志：加入知识库组件加入成功量统计
          this.submitSensors('kng_add_succeed', {
            scene: this.scene,
            databaseID: libId,
            libType: this.libType // 知识库类型 1-全员知识库 2-协作知识库 3-个人知识库
          });
          window.localStorage.setItem('biz_libId', libId);
          window.localStorage.setItem('biz_catalogId', catalogId);
          this.showLinkMessage('success', this.$t('pc_biz_msg_addsuccess'/** 加入成功 */), res[0].id);
          this.visible = false;
        }).catch(e => {
          try {
            e = e.error || {};
          } catch (_) {
            e = {};
          }
          let data = e.data || [];
          if (e.key === 'apis.knglib.NotExists') { // 知识库、文件夹不存在
            this.toast(this.$t('pc_biz_msg_foldernotexited'/** 知识库或文件夹被删除 */), 'error');
            this.$refs.libSelect.resetSearch();
            this.$refs.folderSelect.tree = null;
            this.init();
          } else if (e.key === 'apis.knowledege.file.repeat' && data.length > 0) { // 重复加入
            this.showLinkMessage('warning', this.$t('pc_biz_msg_fileexited'/** 该文件已存在，不允许重复加入 */), data[0]);
          } else {
            this.toast(e.message, 'error');
          }
        }).then(() => {
          this.submiting = false;
        });
      }).catch(() => {});
    },
    // 知识库改变
    libChange(data) {
      // 人员在库中的角色：1.管理员 2.成员 3.超级管理员
      this.hasCreatePermission = data.libPerType === 1 || data.libPerType === 3;
      let id = data.id;
      this.libType = data.libType;
      // 不是第一次加载知识库数据
      if (id !== this.ruleForm.libId) {
        this.$refs.folderSelect.initData({ id, label: this.$t('pc_biz_lbl_rootfolder'/** 根目录 */) });
        this.ruleForm.libId = id;
        this.ruleForm.catalogId = id;
      }
    },
    // 新建目录
    addFolder(data, callback) {
      this.addFolderVisible = true;
      this.$nextTick(() => {
        this.$refs.add.init(data).then(res => {
          callback(res);
        });
      });
    },
    toast(e, type = 'success') {
      FrontMessage.closeAll();
      let msg;
      if (type === 'error' && typeof e === 'object') {
        try {
          msg = e.error.message;
        } catch (e) {}
      } else {
        msg = e;
      }
      msg && FrontMessage[type](msg);
    },
    showLinkMessage(type, msg, kngId, duration = 5000) {
      FrontMessage.closeAll();
      const h = this.$createElement;
      this.f = FrontMessage({
        message: h('p', null, [
          h('span', null, msg),
          h('span', {
            class: 'color-primary-6 hand',
            style: 'margin-left:32px;font-size:12px;',
            on: {
              click: () => {
                kngId && window.open(`${this.baseUrl}/knglib/#/detail?kngId=${kngId}`);
              }
            }
          }, this.$t('pc_biz_lbl_see'/** 立即查看 */))
        ]),
        type,
        duration
      });
    },
    closed() {
      this.resolve();
      this.resolve = null;
      this.loading = false;
      this.submiting = false;
    }
  }
};
</script>
